// components/PerspectiveUploadModal.jsx

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom'; // Import ReactDOM for the portal
import perspectiveStyles from './PerspectiveModal.module.css'; // Import specific styles for Perspective Upload Modal
import buttonStyles from '/components/Buttons/Buttons.module.css';
import blurStyles from '/styles/BlurBackground.module.css'; // Import styles for blur background
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon component
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'; // Correct import of the 'times circle' icon

const PerspectiveUploadModal = ({ isOpen, onClose }) => {
  const [modalContainer, setModalContainer] = useState(null);

  useEffect(() => {
    // Set up the modal container for the portal
    const container = document.getElementById('modal-root');
    setModalContainer(container);
  }, []);

  // Ensure the modal is only rendered when open and the container exists
  if (!isOpen || !modalContainer) return null;

  // Define the modal content
  const modalContent = (
    

    <div
      className={perspectiveStyles['perspective-upload-modal']}
      role="dialog"
      aria-modal="true"
      aria-labelledby="perspective-modal-title"
    >
      {/* Corrected Close Button */}
      <button
        className={perspectiveStyles['perspective-modal-close']} 
        onClick={onClose} 
        aria-label="Close modal"
      >
        <FontAwesomeIcon icon={faTimesCircle} size="2x" />
      </button>

      <div className={perspectiveStyles['perspective-upload-modal-url-bar-top']}>
        <div className={perspectiveStyles['perspective-modal-url']}><center>ShuffleDB.com</center></div>
      </div>

      <div
        id="perspective-modal-title"
        className={perspectiveStyles['perspective-modal-title']}
      >
        Upload Perspective
      </div>

      {/* Add additional UI for uploading perspective videos */}
      <div className={perspectiveStyles['perspective-modal-content']}>
        {/* Add UI elements for uploading files or entering data */}
        <p>Upload your perspective videos here.</p>
        <input className={buttonStyles['dark-mode-button']} type="file" />
        <button className={buttonStyles['dark-mode-button']} aria-label="Upload Video">Upload</button>
      </div>

      <div className={perspectiveStyles['perspective-upload-modal-url-bar-bottom']}>
        <div className={perspectiveStyles['perspective-modal-url']}><center>ShuffleDB.com</center></div>
      </div>
    </div>
  );

  // Render the modal using ReactDOM.createPortal to ensure it renders correctly
  return ReactDOM.createPortal(modalContent, modalContainer);
};

export default PerspectiveUploadModal;
